<template>
<b-container fluid>
    <b-row>
        <b-col><ActionBarPayment/></b-col>        
    </b-row>
    <b-row>
        <b-col>
          <CashMovInput/>          
        </b-col>         
    </b-row>
</b-container>
</template>

<script>
import ActionBarPayment from '@/components/ActionBarPayment.vue'
import mixin from '@/components/mixin.js'
import CashMovInput from '@/components/CashMovInput.vue'

export default {
  mixins:[mixin],
  name: 'CashMovs',
  components: {    
    ActionBarPayment,
    CashMovInput  
  },
  created: function () {
        this.$store.commit('clearPaymMethod')        
  },
}
</script>